import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { CustomersService } from '../rest_services/customers.service';
import { CustomValidationService } from '../rest_services/services/custom-validation.service';
import { UserService } from '../rest_services/user.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css']
})

export class ProfilComponent implements OnInit {
  
    title = 'wam_ng';
    logged:any;role:any;
    comp:any;
    updateInvoice:boolean=false;
    retrieveInvoice:boolean=true;
    newActionForm: FormGroup;
    retrieveInvoiceLoading:boolean =true;
    UpdateInvoiceLoading:boolean =false;
    user_fullname:string="";
    user_phone:string="";
    user_avatar:any="";
    personal_avatar:any="data:image/jpg;base64,";
    company_logo:any="data:image/jpg;base64,";
    user_email:string="";
    company_name:string="";
    company_city:string="";
    company_address:string="";
    company_phone:string="";
    company_sector:string="";
    loading_indicator:boolean=true;
    personalinfo:FormGroup;
    entrepriseinfo:FormGroup;
    facturForm!:FormGroup;
    profilesSubscription!: Subscription;
    uuid:any = null;

    versionInfo: { version: string, lastUpdate: string } = { version: '', lastUpdate: '' };
    version: boolean =false;

    updateGeneInfosLoading:boolean = false;
    retreiveGeneInfos:boolean=true;
    updateGeneInfos:boolean=false;
    retrieveGeneInfoLoading:boolean = true;
  constructor(private fb: FormBuilder, private CustomValidator: CustomValidationService,
    private userServiceservice: UserService,private passServiceService: UserService,
    private customersService:CustomersService) {
      this.facturForm = this.fb.group({
        'adresseSiegeSocial': [''],
        'siteWeb': ['', [Validators.pattern('^(https?://)?www\\.([\\w\\.-]+)\\.([a-z]{2,4})(/.*)?$')]],
        'telephoneFixe': ['', [Validators.pattern('^(\\+212)?[0-9]{10}$')]],
        'telephoneMobile': ['', [Validators.pattern('^(\\+212)?[0-9]{10}$')]],
        'statutJuridique': [''],
        'capitalSocial': [''],
        'identifiantFiscal': [''],
        'patente': [''],
        'registreCommerce': [''],
        'cnss': [''],
        'identifiantICE': ['',[this.iceValidator]],
    });
    this.newActionForm = this.fb.group({
      'older': ['', [Validators.required ]],
      'newer' : ['', [Validators.required,Validators.minLength(6)]],
      'confirmation' : ['', Validators.required],
    },{     
      validator: this.CustomValidator.passwordMatchValidator("newer","confirmation")
    });
    this.personalinfo = this.fb.group({
      'personal_avatar': [''],
      'name': ['', Validators.required],
      'personal_phone' : ['', [Validators.pattern("^((\\+91-?)|0)?[0-9+]{10,13}$")]],
      'personal_email' : ['', [Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
    this.entrepriseinfo = this.fb.group({
      'company_reason': ['', Validators.required],
      'company_sector': ['', Validators.required],
      'company_phone' : ['', [Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9+]{10,13}$")]],
      'company_city': ['', Validators.required],
      'company_address': ['', Validators.required],
      'company_logo': ['']
    })
   }
   iceValidator(control: FormControl): { [key: string]: boolean } | null {
  const ice = control.value;
  const icePattern = /^[0-9]{15}$/; // 15 digits and only numbers

  if (icePattern.test(ice)) {
    return null; // ICE is valid
  } else {
    return { 'invalidICE': true }; // ICE is invalid
  }
}


  ngOnInit(): void {
    if(localStorage.getItem("role")!=undefined && localStorage.getItem("role")!=null) {
      this.role =localStorage.getItem("role");
    }else{
      this.role =sessionStorage.getItem("role")
    }
    this.Profil();
    this.getCities();
    this.getVersion();
    this.getCompanyInvoice();
  }

  getVersion(){
    this.userServiceservice.getVersion();
    this.userServiceservice.versionSubject.subscribe(
      (response: any) => {
        this.version=true;
        this.versionInfo.version = response?.version;
        this.versionInfo.lastUpdate = response?.lastUpdate;
      },
      (error) => {
        console.error('Error retrieving version:', error);
      }
    );
  }
  InitProfil(){
    this.user_phone = "";
    this.personalinfo.controls.name.setValue("");
    this.user_email = "";
    this.personalinfo.controls.personal_phone.setValue("");
    this.Profil();
  }
  InitFormCompany(){
    this.retreiveGeneInfos= !this.retreiveGeneInfos;
    this.updateGeneInfos= !this.updateGeneInfos;
    this.Profil();
  }

  resetInfo(){
    this.entrepriseinfo.reset();
  }

  passRequest:any;
  pass:any="";
  addOrUpdateLoading:boolean = false;
  Pass(){
    var formvalues = this.newActionForm.value;
    this.addOrUpdateLoading = true;
    if(this.newActionForm.valid){
      this.passRequest = {
        older :formvalues.older,
        newer:formvalues.newer,
        confirmation:formvalues.confirmation
      }
      this.passServiceService.passRequest = this.passRequest;
      this.passServiceService.getPass();
      this.passServiceService.passSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="be1273bf6af9df1d14821fbf4602f2e5"){
          this.pass = {
            older :data.older,
            newer :data.newer,
            confirmation :data.confirmation
          };$("#successSave").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successSave").hide();
          }, 5000);
        }else{
          $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
        }this.addOrUpdateLoading = false;
      },)
    }
  }
  city:any;
  pk_start:any=null;pk_end:any=null;myPack:any=null;
  Profil(){
    this.userServiceservice.getProfil();
    this.userServiceservice.profilSubject.subscribe(
      ( data: any ) => {
        if(data.code =="e489dde186171d8d5bed8221ce98b336"){
          this.user_fullname = data.profile.personal.user_fullname;
          this.personalinfo.controls.name.setValue(this.user_fullname);
          this.user_phone = data.profile.personal.user_phone;
          this.personalinfo.controls['name'].disable();
          this.user_avatar = data.profile.personal.user_avatar;
          this.urllink = 'data:image/jpg;base64,'+this.user_avatar
          this.user_email = data.profile.personal.user_email;
          if(data.profile.company != null && data.profile.company != undefined){
            if(data.profile.company.pk != null && data.profile.company.pk != undefined){
              if(data.profile.company.pk.pk==="b3ac1552-c4b5-11ed-b4dd-00163ee67c31"){
                this.myPack = "Sur mesure";
              }else {
                this.myPack = "Basique";
              }
              this.pk_start = data.profile.company.pk.pk_start;
              this.pk_end = data.profile.company.pk.pk_end;
            }else {
              this.myPack = "Basique";
            }
            this.retrieveGeneInfoLoading= false;
            this.company_name = data.profile.company.company_name;
            this.entrepriseinfo.controls.company_reason.setValue(data.profile.company.company_name);
            this.company_city = data.profile.company.company_city;
            this.entrepriseinfo.controls.company_city.setValue(data.profile.company.company_city);
            this.company_address = data.profile.company.company_address;
            
            this.entrepriseinfo.controls.company_address.setValue(data.profile.company.company_address);
            // this.city=data.profile.company.city;
            this.entrepriseinfo.controls.company_city.setValue(data.profile.company.city);
            if(data.profile.company.company_logo!=null && data.profile.company.company_logo!=undefined){
              this.company_logo = data.profile.company.company_logo;
              this.urllink1 = 'data:image/jpg;base64,'+this.company_logo
            }else {
              this.company_logo="../../../assets/img/logo.jpg";
              this.urllink1 = '../../../assets/img/logo.jpg';
            }            
            this.company_phone = data.profile.company.company_phone;
            this.entrepriseinfo.controls.company_phone.setValue(data.profile.company.company_phone);
            this.company_sector = data.profile.company.company_sector;
            this.entrepriseinfo.controls.company_sector.setValue(data.profile.company.company_sector);
          }
        }this.loading_indicator = false;
      })
      
  }
  avatar:any=null;
  showLogo(){
    this.avatar = this.user_avatar;
    this.user_avatar = this.company_logo ;
  }
  showAvatar(){
    this.user_avatar = this.avatar ;
  }
  refCities:any[]=[];
  getCities(){
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
        }
      },
    )  
  }

  urllink:string ="../../../assets/img/unknown_user.jpg";
  urllink1:string ="../../../assets/img/unknown_user.jpg";
  selectFiles(event:any){
    if(event.target.files){
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = (event:any)=>{
        this.urllink = event.target.result;
        this.urllink1 = event.target.result;
      }
    }
  }
  infoRequest:any;
  info:any;
  personalid:any;
  Infoupdate(id:any){
    var formvalues = this.personalinfo.value;
    this.addOrUpdateLoading = true;
    if(this.personalinfo.valid){
      console.log(this.urllink);
      
      this.infoRequest = {
        personal_phone :formvalues.personal_phone,
        personal_email:formvalues.personal_email,
        personal_avatar:this.urllink
      }
      this.passServiceService.infoRequest = this.infoRequest;
      this.passServiceService.getInfoupdate();
      
      this.passServiceService.infoSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="bf2ce81b31403ef40e2b08b0d4fbe0f6"){
          this.Profil();
          $("#successUpdate").show();
          $('.alert-update-success').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-update-success').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successUpdate").hide();
          }, 8000);
        }else{
          $("#errorUpdate").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#errorUpdate").hide();
          }, 8000);
        }this.addOrUpdateLoading = false;
      },)
    }
  }
  companyRequest:any;
  Companyupdate(){
    var formvalues = this.entrepriseinfo.value;
    this.updateGeneInfosLoading = true;
    if(this.entrepriseinfo.valid){
      this.companyRequest = {
        company_reason :formvalues.company_reason,
        company_sector:formvalues.company_sector,
        company_phone:formvalues.company_phone,
        company_city:formvalues.company_city,
        company_address:formvalues.company_address,
        company_logo:this.urllink1
      }
      if(this.companyRequest.company_logo=='../../../assets/img/logo.jpg'){
        this.companyRequest.company_logo = null;
      }
      this.passServiceService.companyRequest = this.companyRequest;
      this.passServiceService.getCompanyupdate();
      this.passServiceService.companySubject.subscribe(
      ( data: any ) => {
        this.updateGeneInfosLoading = false;
        if(data.code =="bf2ce81b31403ef40e2b08b0d4fbe0f6"){
          this.Profil();
          this.InitFormCompany();
          $("#successUpdate").show();
          $('.alert-update-success').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-update-success').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successUpdate").hide();
          }, 8000);
        }else{
          $("#errorUpdatecompany").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#errorUpdatecompany").hide();
          }, 8000);
        }
      },)
    }
  }

  showForm(){
    this.retrieveInvoice= !this.retrieveInvoice;
    this.updateInvoice= !this.updateInvoice;
    this.bindInvoiceToForm(this.invoice);
  }

  invoice!:any;
  getCompanyInvoice() {
    this.userServiceservice.getCompanyInvoice();
    this.userServiceservice.retiereveInvoiceSubject.subscribe(
      (resp: any) => {
        if (resp.code == "e132482aad253ebf99de0fc1399f1b5a") {
          this.invoice = resp.invoiceEnvelop;
          this.bindInvoiceToForm(resp.invoiceEnvelop)
        }
        this.retrieveInvoiceLoading = false;
      },
      (error) => {
        console.error('Error retrieving version:', error);
        this.retrieveInvoiceLoading = false;

      }
    );
  }

  bindInvoiceToForm(invoiceEnvelop: any) {
    this.facturForm.patchValue({
      adresseSiegeSocial: invoiceEnvelop?.companyAddress,
      siteWeb: invoiceEnvelop?.companyWebsite,
      telephoneFixe: invoiceEnvelop?.companyPhone,
      telephoneMobile: invoiceEnvelop?.companyMobile,
      statutJuridique: invoiceEnvelop?.companyLegalStatus,
      capitalSocial: invoiceEnvelop?.companyCapital,
      identifiantFiscal: invoiceEnvelop?.companyFiscalIdentifier,
      patente: invoiceEnvelop?.companyPatente,
      registreCommerce: invoiceEnvelop?.companyCommerceRegistry,
      cnss: invoiceEnvelop?.companySocialSecurity,
      identifiantICE: invoiceEnvelop?.companyEnterpriseIdentifier,
    });
    this.uuid = invoiceEnvelop?.uuid;
  }
  mssgSucces:string='';
  SaveInvoice() {
    this.UpdateInvoiceLoading = true;
    const body = {
      uuid: this.uuid,
      adresseSociete: this.facturForm.get("adresseSiegeSocial")?.value,
      siteWeb: this.facturForm.get("siteWeb")?.value,
      telephoneFixe: this.facturForm.get("telephoneFixe")?.value,
      telephoneMobile: this.facturForm.get("telephoneMobile")?.value,
      statutJuridique: this.facturForm.get("statutJuridique")?.value,
      capitalSocial: this.facturForm.get("capitalSocial")?.value,
      identifiantFiscal: this.facturForm.get("identifiantFiscal")?.value,
      patente: this.facturForm.get("patente")?.value,
      registreCommerce: this.facturForm.get("registreCommerce")?.value,
      cnss: this.facturForm.get("cnss")?.value,
      ice: this.facturForm.get("identifiantICE")?.value
    };
    
    this.userServiceservice.updateInvoice(body);
    this.userServiceservice.addInvoiceSubject.subscribe(
      (resp: any) => {        
        this.UpdateInvoiceLoading = false;
        if (resp.code == "d42450141458b27957b5d5fbee7f9205") {
          this.retrieveInvoice= true;
          this.updateInvoice= false;
          this.facturForm.reset();
          this.invoice = resp.invoiceEnvelop;
          this.mssgSucces='La facturation est bien enregistrée'
          $("html, body").animate({scrollTop:0})
          $("#successInvoice").show();
          $('.alert-update-success').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-update-success').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successInvoice").hide();
          }, 8000);
        }
        else if (resp.code == "e132482aad253ebf99de0fc1399f1b5a") {
          this.retrieveInvoice= true;
          this.updateInvoice= false;
          this.invoice = resp.invoiceEnvelop;
          this.facturForm.reset();
          this.mssgSucces='La facturation est bien modifié'
          $("html, body").animate({scrollTop:0})
          $("#successInvoice").show();
          $('.alert-update-success').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-update-success').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successInvoice").hide();
          }, 8000);
        }
      },
      (error) => {
        console.error('Error retrieving version:', error);
        this.UpdateInvoiceLoading = false;
        $("#FailedInvoice").show();
        $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          // $(this).removeClass();
        });
        setTimeout(()=>{
          $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          $("#FailedInvoice").hide();
        }, 8000);
      }
    );
  }
}
